// Vertaal Supabase Auth-foutmeldingen naar Nederlands voor de gebruiker.
// Onbekende meldingen vallen terug op een algemene tekst (de technische melding gaat naar console).

const TRANSLATIONS = [
  [/invalid login credentials/i, 'Onjuist e-mailadres of wachtwoord.'],
  [/email not confirmed/i, 'Je e-mailadres is nog niet bevestigd. Controleer je inbox.'],
  [
    /invalid totp code|invalid mfa|code.*(invalid|expired)/i,
    'Ongeldige code. Controleer je authenticator-app en probeer het opnieuw.',
  ],
  [/rate limit|too many requests/i, 'Te veel pogingen. Wacht even en probeer het opnieuw.'],
  [
    /friendly name.*already exists/i,
    'Er staat nog een eerdere 2FA-poging open. Probeer het opnieuw.',
  ],
  [/aal2.*required|insufficient_aal/i, 'Bevestig eerst je 2FA-code om deze actie uit te voeren.'],
  [/network|failed to fetch/i, 'Geen verbinding met de server. Controleer je internetverbinding.'],
  [/password should be at least/i, 'Het wachtwoord is te kort.'],
  [
    /same password|different from the old password/i,
    'Het nieuwe wachtwoord moet verschillen van het huidige.',
  ],
  [/user not found/i, 'Geen account gevonden met dit e-mailadres.'],
  [/session.*(expired|missing|not found)|jwt expired/i, 'Je sessie is verlopen. Log opnieuw in.'],
];

export function translateAuthError(error, fallback = 'Er is iets misgegaan. Probeer het opnieuw.') {
  const message = typeof error === 'string' ? error : error?.message;
  if (!message) return fallback;
  const match = TRANSLATIONS.find(([pattern]) => pattern.test(message));
  if (match) return match[1];
  console.warn('[auth] Onvertaalde foutmelding:', message);
  return fallback;
}
